// Prod_US person fields: initials, birth month and year, height, sex. Used when the person is
// added (About) and edited (Details), so both follow the same rules (prodUsRules.js).
import React from "react";
import { birthYears, FEET, INCHES } from "./prodUsRules";
import { MONTHS, pt } from "./prodUsStrings";

const ProdUsAboutFields = ({ about, setAbout, errors: e = {} }) => {
  const set = (key) => (event) =>
    setAbout((d) => ({ ...d, [key]: event.target.value }));
  const setInitial = (key) => (event) =>
    setAbout((d) => ({
      ...d,
      [key]: event.target.value
        .replace(/[^A-Za-z]/g, "")
        .slice(0, 1)
        .toUpperCase(),
    }));
  const select = (id, placeholder, options, key, bad, label) => (
    <select
      id={id}
      className={`ainp${bad ? " bad" : ""}`}
      aria-label={label}
      value={about[key]}
      onChange={set(key)}
    >
      <option value="">{placeholder}</option>
      {options.map(([value, text]) => (
        <option key={value} value={value}>
          {text}
        </option>
      ))}
    </select>
  );
  const err = (message) =>
    message ? (
      <p className="aerr" role="alert">
        {message}
      </p>
    ) : null;
  return (
    <>
      <div className="row2">
        <label className="afield">
          <span>{pt("fi")}</span>
          <input
            id="produs-fi"
            className={`ainp${e.fi ? " bad" : ""}`}
            maxLength={1}
            autoCapitalize="characters"
            autoComplete="off"
            value={about.fi}
            onChange={setInitial("fi")}
          />
        </label>
        <label className="afield">
          <span>{pt("li")}</span>
          <input
            id="produs-li"
            className={`ainp${e.li ? " bad" : ""}`}
            maxLength={1}
            autoCapitalize="characters"
            autoComplete="off"
            value={about.li}
            onChange={setInitial("li")}
          />
        </label>
      </div>
      {err(e.fi || e.li)}
      <div className="row2">
        <div className="afield">
          <span>{pt("bmonth")}</span>
          {select(
            "produs-bm",
            pt("month"),
            MONTHS.map((m, i) => [i + 1, m]),
            "birthMonth",
            e.birth && !about.birthMonth,
            pt("bmonth"),
          )}
        </div>
        <div className="afield">
          <span>{pt("byear")}</span>
          {select(
            "produs-by",
            pt("year"),
            birthYears().map((y) => [y, String(y)]),
            "birthYear",
            !!e.birth && (!about.birthYear || !!about.birthMonth),
            pt("byear"),
          )}
        </div>
      </div>
      {err(e.birth)}
      <div className="afield">
        <span>{pt("height")}</span>
        <div className="row2">
          {select(
            "produs-ft",
            pt("feet"),
            FEET.map((f) => [f, `${f} ${pt("ft")}`]),
            "feet",
            e.height && about.feet === "",
            pt("feet"),
          )}
          {select(
            "produs-in",
            pt("inches"),
            INCHES.map((i) => [i, `${i} ${pt("in")}`]),
            "inches",
            e.height && about.inches === "",
            pt("inches"),
          )}
        </div>
      </div>
      {err(e.height)}
      <div className="afield">
        <span>{pt("sex")}</span>
        <div className="seg">
          <button
            type="button"
            aria-pressed={about.sex === "M"}
            onClick={() => setAbout((d) => ({ ...d, sex: "M" }))}
          >
            {pt("male")}
          </button>
          <button
            type="button"
            aria-pressed={about.sex === "F"}
            onClick={() => setAbout((d) => ({ ...d, sex: "F" }))}
          >
            {pt("female")}
          </button>
        </div>
      </div>
      {err(e.sex)}
    </>
  );
};

export default ProdUsAboutFields;
